import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import image from './outreach@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="outreach">
    <h1>京斯敦外展項目</h1>
    <p>
      我們很自豪能與United World Schools 慈善機構建立特別的夥伴關係。United World
      Schools是一間致力改善世界上部分落後地區孩子教育的機構，為偏遠及被邊緣化地區的孩子免費提供基礎教育。
    </p>
    <p>
      京斯敦一直與位於柬埔寨農村的Jong Ra
      School合作。過去，這個地方並沒提供教育予學生，惟一的出路就是稻米種植，而且該處人口販賣與飢荒問題十分嚴重。現在，隨着Jong
      Ra
      School的成立，情況開始得以改善。孩子們可以有更好的未來，並明白除了稻米種植外，他們實現更多其他的夢想。此外，他們可獲得更多食物，孩子們亦在更安全的環境下成長。以上的成功均有賴京斯敦大家庭全力支持。從文具、桌椅、教師培訓與薪酬到學校的建設，京斯敦學生、家長及教師皆提供贊助。
    </p>
    <p>
      每年，我們均訂立籌款港幣七萬八千元的目標，以不斷支持Jong Ra School
      。校內一群四、五、六年級的學生組成「世界公民小組」，熱心承擔這個重大責任。
      世界公民小組每週聚會一次，討論及計劃有關籌款及宣傳活動。
    </p>
    <img src={image} alt="Kingston outreach" />
  </ContentLayout>
);
